var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tree && _vm.tab == 'interactive')?_c('div',[_c('TreeViewInteractive',{attrs:{"tree":_vm.tree,"decisionId":_vm.decisionId,"decisionName":_vm.decisionName}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }